import { render, staticRenderFns } from "./lazyloadimage.vue?vue&type=template&id=45db8249&scoped=true"
import script from "./lazyloadimage.vue?vue&type=script&lang=js"
export * from "./lazyloadimage.vue?vue&type=script&lang=js"
import style0 from "./lazyloadimage.vue?vue&type=style&index=0&id=45db8249&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45db8249",
  null
  
)

export default component.exports